export default {
    LOGIN: "Login",
    FORGET_PASSWORD: "Forget Password",
    OTP_VERIFICATION: "OTP Verification",
    LOGOUT: "Logout",
    RESET_PASSWORD: "Reset Password",
    PDF_LISTING: "PDF Listing",
    WEB_FORM: "Web Form",
    ACCOUNT: "Account"
};
